import { EntityDto } from './../entity/entity.dto';
import { IdentityDto } from './../shared/identity.dto';
import { ProductLineLocaleDto } from './locale.dto';
import { ProductLineProcessingDto } from './processing/processing.dto';
import { CapabilityDto } from './../shared/capability.dto';
import { ProductBarCodeDto } from './../product/bar-code.dto';
import { RiskComplianceDto } from './risk-compliance.dto';

export class ProductLineDto {
  brand?: string;
  entity: EntityDto;
  identity: IdentityDto;
  legalEntity: string;
  account?: string;
  locales?: ProductLineLocaleDto[];
  barcodes?: ProductBarCodeDto[];
  capabilities?: CapabilityDto[];
  processing?: ProductLineProcessingDto;
  type: string;
  riskCompliance?: RiskComplianceDto;

  constructor(d?: ProductLineDto) {
    if (!d) {
      return;
    }

    Object.assign(this, d || {});

    if (d.locales) {
      this.locales = d.locales.map(l => new ProductLineLocaleDto(l));
    }

    if (d.entity) {
      this.entity = new EntityDto(d.entity);
    }
  }
}
